import useEmblaCarousel from "embla-carousel-react";

interface Strength {
  id: number;
  title: string;
  subtitle?: string;
}

interface Props {
  cover: string;
  logo?: string;
  guestName: string;
  strengths: Strength[];
  expirationDate?: string;
  heading?: string;
  onScrollToOffer?: () => void;
}

export default function MinisiteCover({
  cover,
  logo,
  guestName,
  strengths,
  expirationDate,
  heading,
  onScrollToOffer,
}: Props) {
  const [emblaRef] = useEmblaCarousel({
    align: "start",
    dragFree: true,
    containScroll: "trimSnaps",
  });

  return (
    <div className="rounded-2xl overflow-hidden">
      {cover ? (
        <div className="relative h-screen overflow-y-auto">
          <img src={cover} alt="" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
          {logo && (
            <div className="absolute top-6 left-6 md:top-8 md:left-8">
              <img
                src={logo}
                alt=""
                className="h-14 md:h-20 w-auto object-contain"
              />
            </div>
          )}
          <div className="absolute inset-x-6 top-[15%] md:top-[20%] text-white space-y-4 max-w-2xl">
            <p className="text-sm md:text-base opacity-80">
              {heading || "Benvenuti"}
            </p>
            <h1 className="text-3xl md:text-5xl font-bold">
              Gentile {guestName}
            </h1>
            {expirationDate && (
              <div className="flex items-center gap-3 pt-1">
                <span className="text-xs md:text-sm font-medium text-amber-300 bg-black/30 px-3 py-1 rounded-full">
                  Scade il{" "}
                  {new Date(expirationDate).toLocaleDateString("it-IT")}
                </span>
                {onScrollToOffer && (
                  <button
                    onClick={onScrollToOffer}
                    className="text-xs md:text-sm text-white/90 hover:text-white underline underline-offset-4 font-medium bg-transparent border-none p-0 cursor-pointer"
                  >
                    Visualizza offerta &darr;
                  </button>
                )}
              </div>
            )}
          </div>
          {strengths.length > 0 && (
            <div
              className="absolute bottom-6 inset-x-6 overflow-hidden"
              ref={emblaRef}
            >
              <div className="flex gap-3">
                {strengths.map((s) => (
                  <div
                    key={s.id}
                    className="flex-shrink-0 w-40 h-40 rounded-2xl bg-white/15 backdrop-blur-md border border-white/20 p-3 flex flex-col justify-center"
                  >
                    <h3 className="text-sm font-semibold text-white text-center">
                      {s.title}
                    </h3>
                    {s.subtitle && (
                      <p className="text-xs text-white/80 mt-1 text-center line-clamp-3">
                        {s.subtitle}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="h-screen flex items-center justify-center text-xl text-muted-foreground bg-muted/30 rounded-2xl">
          Cover
        </div>
      )}
    </div>
  );
}
